import { render, staticRenderFns } from "./GameCardBlueTheme.vue?vue&type=template&id=322a5ae7"
import script from "./GameCardBlueTheme.vue?vue&type=script&lang=js"
export * from "./GameCardBlueTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports